"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleFormulaNode = void 0;
const tree_node_1 = require("./base/tree.node");
const internal_node_1 = require("./base/internal.node");
const formula_node_1 = require("./formula.node");
const math_nodes_1 = require("./math_nodes");
const comparison_node_1 = require("./comparison.node");
const boolean_node_1 = require("./boolean.node");
const symbol_node_1 = require("./symbol.node");
const antlr_files_1 = require("../antlr_files");
const constants_1 = require("../constants");
const array_node_1 = require("./array.node");
class SimpleFormulaNode extends internal_node_1.InternalNode {
    _children;
    _formulaName;
    _originalSymbol;
    constructor(originalNode, parent, prefix) {
        super({ getText: () => '' }, parent);
        const newName = this.getExprFormulaName(originalNode);
        this.formulaName = prefix ? `${prefix}${newName}` : newName;
        this.replaceOriginalNode(originalNode);
        this.handleChildren(originalNode);
        this.parent = parent;
        this._children = originalNode.children;
    }
    set formulaName(value) {
        this._formulaName = value;
    }
    accept(v) {
        if (v.visitSimpleFormula)
            v.visitSimpleFormula(this);
        this.visitChildren(v);
    }
    getReturnType() {
        return '';
    }
    handleChildren(originalNode) {
        if (!this._originalSymbol || this._originalSymbol.terminalType !== antlr_files_1.Lexer.BOOLEAN_OPERATIONS)
            return;
        const arrayNode = new array_node_1.ArrayNode(originalNode.children);
        arrayNode.parent = this;
        originalNode.children = [arrayNode];
    }
    replaceOriginalNode(originalNode) {
        for (const child of originalNode.children) {
            child.parent = this;
        }
        const parent = originalNode.parent;
        const children = [
            ...(parent instanceof formula_node_1.FormulaNode ? parent.rawChildren : parent?.children ?? []),
        ];
        const nodeIndex = children?.findIndex(child => Object.is(child, originalNode)) ?? -1;
        if (!parent || !children || nodeIndex === -1)
            return;
        children[nodeIndex] = this;
        parent.children = children;
    }
    toString() {
        if (!this.hasChildren())
            return '';
        return `${this._formulaName}(${this._children.map(child => child.toString()).join(', ')})`;
    }
    get treeNodeType() {
        return tree_node_1.TreeNodeType.SIMPLE_FORMULA_NODE;
    }
    getExprFormulaName(node) {
        let name = '';
        if (!(node instanceof math_nodes_1.PlusMinusExprNode ||
            node instanceof comparison_node_1.ComparisonExprNode ||
            node instanceof math_nodes_1.TimesDivExprNode ||
            node instanceof boolean_node_1.BooleanExprNode ||
            node instanceof math_nodes_1.PowExprNode))
            return name;
        const symbolNode = node.children.find(child => child instanceof symbol_node_1.SymbolNode);
        this._originalSymbol = symbolNode;
        if (!symbolNode)
            return name;
        switch (symbolNode.terminalType) {
            case antlr_files_1.Lexer.BOOLEAN_OPERATIONS:
                name = constants_1.BOOLEAN_OPERATIONS_TO_BQ_FORMULA[symbolNode.token];
                break;
            case antlr_files_1.Lexer.COMPARISON_OPERATIONS:
                name = constants_1.COMPARISON_OPERATIONS_TO_BQ_FORMULA[symbolNode.token];
                break;
            default:
                name = constants_1.EXP_SYMBOL_TO_BQ_FORMULA[symbolNode.terminalType];
                break;
        }
        node.children = node.children.filter(child => !(child instanceof symbol_node_1.SymbolNode));
        return name;
    }
}
exports.SimpleFormulaNode = SimpleFormulaNode;
